import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";

interface MovieSectionProps {
  title: string;
  subtitle: string;
  icon: string;
  movies: Movie[];
  moreLink?: string;
}

export default function MovieSection({ title, subtitle, icon, movies, moreLink }: MovieSectionProps) {
  return (
    <section aria-label={title}>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className={`${icon} text-xl text-primary-500`} aria-hidden="true" />
            {title}
          </h2>
          <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
        </div>
        {moreLink && (
          <Link
            to={moreLink}
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            查看更多
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        )}
      </div>

      {movies.length === 0 ? (
        <p className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
          暂无相关资源，敬请期待
        </p>
      ) : (
        <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </section>
  );
}